import React, { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Layout from '../../../components/layout/layout'
import '../mlOutRails/mlOutRails.scss'
import './articlePage.scss'
import { LanguageContext } from '../../../components/LanguageSwitcher/LanguageContext'
import { ArticleBackLink, ArticleNextCta } from '../../../components/ArticleNav/ArticleNav'
import ArticleCta from '../../../components/ArticleCta/ArticleCta'
import ArticleListen from '../../../components/ArticleListen/ArticleListen'
import ArticleSummary from '../../../components/ArticleSummary/ArticleSummary'
import Seo, { articleJsonLd, articleBreadcrumbs } from '../../../components/Seo/Seo'
import { articleCovers, articleMeta, localizeArticle } from './articleShared'

/**
 * Template for articles defined in data/articles.js. Uses the same layout
 * and styles as the older hand-written article pages, so both look alike.
 */
const ArticlePage = ({ article: source, next }) => {
  const { translations, selectedLanguage } = useContext(LanguageContext)
  const article = localizeArticle(source, translations)
  const cover = articleCovers[source.cover]
  const path = `/articles/${source.slug}`
  const meta = articleMeta(source, article, selectedLanguage, translations)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [source.slug])

  return (
    <Layout>
      <Seo
        title={source.seoTitle}
        description={source.description}
        type='article'
        image={cover}
        jsonLd={[
          articleJsonLd({
            headline: source.title,
            description: source.description,
            image: cover,
            path,
            datePublished: source.date,
            author: source.author,
          }),
          articleBreadcrumbs(source.title, path),
        ]}
      />
      <div className='mlrole-health-container'>
        <div className='mlrole-health healthh-box'>
          <ArticleBackLink />
          <h1 className='article-main-title'>{article.title}</h1>
          <div className='article-author-head-container'>
            <div className='article-author-head'>
              <p>{meta.date}</p>
              <p>•</p>
              <p>{source.author}</p>
            </div>
            <p className='article-author-head'>{meta.read}</p>
          </div>

          <div className='mlrole-health-first-image-box'>
            <img src={cover} alt={source.coverAlt} className='mlrole-health-first-image' width='1600' height='900' />
          </div>
          <ArticleListen />
          <ArticleSummary id={source.slug} />
          <div className='mlrole-health-txt-container'>
            <div className='mlrole-health-txt-child-box'>
              {article.sections.map((section, index) => (
                <React.Fragment key={index}>
                  {section.heading && <h2 className='article-secondaty-title'>{section.heading}</h2>}
                  {section.paragraphs.map((paragraph, j) => <p key={j}>{paragraph}</p>)}
                </React.Fragment>
              ))}

              {source.related && (
                <Link to={source.related.path} className='article-related-service'>
                  <span className='article-related-label'>{translations.artRelatedService || 'Related service'}</span>
                  <span className='article-related-name'>{source.related.label} <span aria-hidden='true'>→</span></span>
                </Link>
              )}
            </div>
          </div>

          <ArticleCta />
          {/* The last new article leads on to the newest of the older ones. */}
          {next
            ? <ArticleNextCta link={next.link} title={translations[`art.${next.slug}.title`] || next.title} />
            : <ArticleNextCta link='/articles/aiChatbots' title={translations.BlogAiChatbots} />}
        </div>
      </div>
    </Layout>
  )
}

export default ArticlePage
